const { expect } = require('chai');
const { jpath } = require('jsonpath-mapper');
const { migratortronApi } = require('./migratortronApi');
const { loadRecordedMock } = require('./util');

describe('Delete entries', () => {
  describe('Recycle entries', () => {
    describe('preview deleting a single entry by id', () => {
      const mock = loadRecordedMock('recycle_entries_includeIds_preview.json');

      it(`should return one entry to delete`, (done) => {
        migratortronApi.post(
          'recycle/entries?includeIds',
          { body: mock.payload },
          (error, response, body) => {
            if (error) done(error);

            expect(body).to.be.an('object');
            if (body.error) done(body.error);

            expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(1);
            done();
          }
        );
      });
    });

    describe('delete a single entry by id', () => {
      const mock = loadRecordedMock('recycle_entries_commit_includeIds.json');

      it(`should delete one entry successfully`, (done) => {
        migratortronApi.post(
          'recycle/entries/commit?includeIds',
          { body: mock.payload },
          (error, response, body) => {
            if (error) done(error);

            expect(body).to.be.an('object');
            if (body.error) done(body.error);

            expect(body.migrateResult.deleted).to.equal(1);
            done();
          }
        );
      });
    });

    describe('repeat the same delete a single entry by id', () => {
      const mock = loadRecordedMock(
        'recycle_entries_commit_includeIds_repeat.json'
      );

      it(`should return an error saying entry is not found`, (done) => {
        migratortronApi.post(
          'recycle/entries/commit?includeIds&repeat',
          { body: mock.payload },
          (error, response, body) => {
            if (error) done(error);

            expect(body).to.be.an('object');
            if (body.error) done(body.error);

            expect(jpath('existing.*.totalCount', body)).to.equal(0);
            expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(0);

            expect(body?.migrateResult.created).to.equal(0);
            expect(body?.migrateResult.updated).to.equal(0);
            expect(body?.migrateResult.deleted).to.equal(0);
            done();
          }
        );
      });
    });
  });

  describe('preview deleting a single entry by id', () => {
    const mock = loadRecordedMock('delete_entries_includeIds_preview.json');

    it(`should return one entry to delete`, (done) => {
      migratortronApi.post(
        'delete/entries?includeIds',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(1);
          done();
        }
      );
    });
  });

  describe('delete a single entry by id', () => {
    const mock = loadRecordedMock('delete_entries_commit_includeIds.json');

    it(`should delete one entry successfully`, (done) => {
      migratortronApi.post(
        'delete/entries/commit?includeIds',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);

          expect(body.migrateResult.deleted).to.equal(1);
          done();
        }
      );
    });
  });

  describe('repeat the same delete a single entry by id', () => {
    const mock = loadRecordedMock(
      'delete_entries_commit_includeIds_repeat.json'
    );

    it(`should return an error saying entry is not found`, (done) => {
      migratortronApi.post(
        'delete/entries/commit?includeIds&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);

          expect(jpath('existing.*.totalCount', body)).to.equal(0);
          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(0);

          expect(body?.migrateResult.created).to.equal(0);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.deleted).to.equal(0);
          done();
        }
      );
    });
  });

  describe('preview deleting entries by multiple contentTypeIds', () => {
    const mock = loadRecordedMock('delete_entries_contentTypeIds_preview.json');

    const entriesCount = mock.response.existing.migratortron?.totalCount;

    it(`should return ${entriesCount} entries to delete`, (done) => {
      migratortronApi.post(
        'delete/entries?contentTypeIds',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);

          expect(body.entriesToMigrate?.migratortron?.totalCount).to.equal(
            entriesCount
          );
          done();
        }
      );
    });
  });

  describe('delete entries by multiple contentTypeIds', () => {
    const mock = loadRecordedMock('delete_entries_commit_contentTypeIds.json');
    const entriesCount =
      mock.response.entriesToMigrate.migratortron?.totalCount;

    it(`should delete ${entriesCount} entries successfully`, (done) => {
      migratortronApi.post(
        'delete/entries/commit?contentTypeIds',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          // TODO: remove - 1 as there was a cms fault when recording mocks
          expect(body.migrateResult.deleted).to.equal(entriesCount - 1);
          done();
        }
      );
    });
  });

  describe('repeat the same delete entries by multiple contentTypeIds', () => {
    const mock = loadRecordedMock(
      'delete_entries_commit_contentTypeIds_repeat.json'
    );

    it(`should return an error saying entry is not found`, (done) => {
      migratortronApi.post(
        'delete/entries/commit?contentTypeIds&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);

          expect(body?.migrateResult.created).to.equal(0);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.deleted).to.equal(0);
          done();
        }
      );
    });
  });
});
